// extracted by mini-css-extract-plugin
export default {"container":"GoogleMapAutocomplete_container__6w7au","header":"GoogleMapAutocomplete_header__AII1u"};